const withQuery = ({ parse, stringify }) => (history) => {
  const enhance = (location) => ({
    ...location,
    query: parse(location.search),
  });

  const diminish = (location) => ({
    ...location,
    search: location.query && typeof location.query === 'object' ? stringify(location.query) : location.search,
  });

  const enhancedHistory = {
    ...history,
    location: enhance(history.location),
    push(path, state) {
      if (typeof path !== 'object') {
        return history.push(path, state);
      }

      return history.push(diminish(path));
    },
    replace(path, state) {
      if (typeof path !== 'object') {
        return history.replace(path, state);
      }

      return history.replace(diminish(path));
    },
    block(prompt) {
      if (typeof prompt !== 'function') {
        return history.block(prompt);
      }

      return history.block((location, action) => prompt(enhance(location), action));
    },
    listen(listener) {
      return history.listen((location, action) => listener(enhance(location), action));
    },
    createHref(location) {
      return history.createHref(diminish(location));
    },
  };

  Object.defineProperties(enhancedHistory, {
    length: {
      get() {
        return history.length;
      },
    },
    action: {
      get() {
        return history.action;
      },
    },
    location: {
      get() {
        return enhance(history.location);
      },
    },
  });

  return enhancedHistory;
};

export default withQuery;
